import axios from 'axios'
import _URL from '../../URL/index';
const limit = 15;

export default {
    services: {
        login: (data) => {
            return axios.post(`${_URL._API}/auth/suppliers`, data);
        },
        validateEmail: (email) => {
            return axios.get(`${_URL._API}/validation/email/${email}`);
        },
        verifyCustomer: (email, owner, type) => {
            return axios.post(`${_URL._API}/customer-exists`, { email: email, owner: owner, type });
        },
        forgotPassword: (email) => {
            return axios.post(`${_URL._API}/auth/suppliers/forgot-password`, { email: email })
        },
        restorePassword: (userId, userType, operation, payload, token) => {
            return axios.put(`${_URL._API}/auth/suppliers/${userId}/restore-password?userType=${userType}&operation=${operation}&token=${token}`, payload)
        },
        refreshToken: (token) => {
            return axios.post(`${_URL._API}/auth/refresh`, {}, { headers: { Authorization: token } })
        },
        checkUniqueEmail: (email) => {
            return axios.post(`${_URL._API}/auth/check-unique-email`, { email: email });
        }
    }
}